import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthly", "annual", "monthlyButton", "annualButton"]

  connect() {
    this.showMonthly()
  }

  showMonthly() {
    this.#showPeriod("monthly")
  }

  showAnnual() {
    this.#showPeriod("annual")
  }

  #showPeriod(period) {
    this.monthlyTargets.forEach((element) => element.classList.toggle("hidden", period !== "monthly"))
    this.annualTargets.forEach((element) => element.classList.toggle("hidden", period !== "annual"))

    this.#setButtonState(this.monthlyButtonTarget, period === "monthly")
    this.#setButtonState(this.annualButtonTarget, period === "annual")
  }

  #setButtonState(button, active) {
    button.setAttribute("aria-pressed", active.toString())

    this.#classesFor(button.dataset.activeClass).forEach((className) => button.classList.toggle(className, active))
    this.#classesFor(button.dataset.inactiveClass).forEach((className) => button.classList.toggle(className, !active))
  }

  #classesFor(classList) {
    return (classList || "").split(" ").filter(Boolean)
  }
}
